export default __webpack_public_path__ + "static/media/img1.d124ecb5.jpg";